"use strict";

var Dropdown = require("app/shared/components/Dropdown/dropdown");
var TruncateText = require("app/shared/components/Truncate/truncate-text");
var ActivitiesListingActions = require("app/screens/Activity/actions/activities-listing-actions");
var ActivitiesListingStore = require("app/screens/Activity/stores/activities-listing-store");
const OPTIONS = {
  includesPeople: {id: "2", name: "da empresa e pessoas relacionadas"},
  includesDeals: {id: "3", name: "da pessoa e negócios relacionados"},
  includesDealsAndPeople: {id: "4", name: "da empresa, pessoas e negócios relacionados"}
}

const HistoryParams = React.createClass({
  mixins: [Reflux.ListenerMixin],
  propTypes: {
    entity: React.PropTypes.string.isRequired,
    entityName: React.PropTypes.string.isRequired,
    includesPeople: React.PropTypes.bool,
    includesDeals: React.PropTypes.bool,
    includesDealsAndPeople: React.PropTypes.bool
  },

  getInitialState: function () {
    const default_option = {
      "empresa": "4",
      "pessoa": "3"
    };
    return { filters: { selectedHistoryOption: default_option[this.props.entity] } };
  },

  componentDidMount: function() {
    this.listenTo(ActivitiesListingStore, this.setState);
  },

  dropdownOptions: function() {
    let defaultOptionText = `da ${this.props.entity} apenas`;
    let options = [{id: "1", name: defaultOptionText}];

    if (this.props.includesPeople) {
      options.push(OPTIONS.includesPeople);
    }

    if (this.props.includesDeals) {
      options.push(OPTIONS.includesDeals);
    }

    if (this.props.includesDealsAndPeople) {
      options.push(OPTIONS.includesDealsAndPeople);
    }

    return options;
  },

  historyParams: function(value) {
    let filters = {};

    filters["selectedHistoryOption"] = value;
    filters["append_related_people"] = ["2", "4"].includes(value);
    filters["append_related_deals"] = ["3", "4"].includes(value);

    return Object.assign({}, this.state.filters, filters);
  },

  updateHistory: function(selectedOption) {
    let params = this.historyParams(selectedOption.value);

    ActivitiesListingActions.getActivities(params, false);
  },

  render: function() {
    return <div className="d-f jc-sb mr-20 ml-20">
      <span className="d-f self-center fs-16">
        <span className="text-wrap">Histórico de atividades da&nbsp;</span>
        <TruncateText text={this.props.entityName} maxWidth="230" className="fw-bold" showTooltip={true}/>
      </span>
      <span id="historyParamsSelector">
        <span className="fs-14 fw-bold self-center">mostrar atividades:</span>
        <Dropdown options={this.dropdownOptions()}
          handleCustomChange={this.updateHistory}
          value={this.state.filters.selectedHistoryOption}
          className="dropdownDefault b-light ml-10 fs-14 w-190"/>
      </span>

    </div>
  }

});


module.exports = HistoryParams;



// WEBPACK FOOTER //
// ./app/screens/Activity/components/HistoryParams/history-params.jsx